import { render } from "./CRMDatatableLeadFormCard.vue?vue&type=template&id=bf6dfd1a&scoped=true"
import script from "./CRMDatatableLeadFormCard.vue?vue&type=script&lang=js"
export * from "./CRMDatatableLeadFormCard.vue?vue&type=script&lang=js"

import "./CRMDatatableLeadFormCard.vue?vue&type=style&index=0&id=bf6dfd1a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6dfd1a"]])

export default __exports__